/* eslint-disable array-callback-return */
import Cookies from 'universal-cookie';
import { MYRES, sendTrackingParams, getReservationInformation, trackView } from './tracking';
import { BOOKING_TOKEN, FUTURE_CRUISE_CREDIT_TYPES } from '../constants';

const cookies = new Cookies();
const FCCR = 'fccr';
const INTERACTION = 'interactions';
const FCC_COUPON_TYPE = 'FUTURE_CREDIT_CERTIFICATE';
export const INTERACTIONS = {
  ERROR_EXPRESS_CHECKOUT: 'error:expressCheckout',
  ERROR_TRAVEL_AGENCY: 'error:sentTravelAgency',
  ERROR_WRONG_NUMBER: 'error:wrongNumber',
  ERROR_TECNICAL_ISSUES: 'error:technicalIssues',
  FCCR_ERROR: 'submission:error',
  FCCR_SUCCESS: 'submission:success',
  SUBMITTED: 'findMyReservationSubmitted',
  SUCCESS: 'success:reservationDisplayed',
};

export const trackPageView = () => {
  const language = cookies.get('language');
  const myresFcc = `${MYRES}:${FCCR}`;
  trackView({
    language,
    pageName: myresFcc,
    siteSection: myresFcc,
  });
};

export const trackFccInteraction = (interaction, trackingParams) => {
  const token = sessionStorage.getItem(BOOKING_TOKEN);
  let tokenData;
  if (token !== null) {
    const reservation = getReservationInformation();
    if (reservation) {
      const { bookingId, sailDate, shipCode } = reservation;
      tokenData = {
        bookingId,
        sailDate,
        shipCode,
      };
    }
  }
  sendTrackingParams(
    {
      eventType: INTERACTION,
      interaction: `${FCCR}:${interaction}`,
      ...tokenData,
      ...trackingParams,
    },
    false,
  );
};

export const trackSubmitFccInteraction = (interaction, { result, bookingPassengers }) => {
  let certs;
  const getFccCodesByType = (credits, type) => {
    return credits
      .filter((fcc) => fcc.type === FUTURE_CRUISE_CREDIT_TYPES[type])
      .map((fcc) => fcc.certificate)
      .join(', ');
  };
  const getFccQuantity = (credits, type) => {
    return credits.filter((fcc) => fcc.type === FUTURE_CRUISE_CREDIT_TYPES[type]).length;
  };
  const FCC_REJECTED_TYPES = [
    'REDEEMED',
    'EXPIRED',
    'MISSMATCH',
    'NON_ELEGIBLE',
    'CURRENCY_MISSMATCH',
    'INVALID',
  ];
  const getAllRejectedCodes = (credits) => {
    return (
      credits
        // eslint-disable-next-line consistent-return
        .map((fcc) => {
          if (FCC_REJECTED_TYPES.includes(fcc.type)) {
            return fcc.certificate;
          }
        })
        .filter((element) => element !== undefined)
    );
  };

  if (result) {
    if (result?.submitFutureCruiseCredits) {
      const { submitFutureCruiseCredits } = result;
      certs = {
        fccCodesReceived: getFccCodesByType(
          submitFutureCruiseCredits,
          FUTURE_CRUISE_CREDIT_TYPES.ACTIVE,
        ),
        fccCodesInvalid: getAllRejectedCodes(submitFutureCruiseCredits).join(', '),
        numberFccsInvalid: getAllRejectedCodes(submitFutureCruiseCredits).length,
        numberFccsReceived: getFccQuantity(
          submitFutureCruiseCredits,
          FUTURE_CRUISE_CREDIT_TYPES.ACTIVE,
        ),
      };
    }
  }
  trackFccInteraction(interaction, {
    bookingPassengers,
    couponsTypes: FCC_COUPON_TYPE,
    ...certs,
  });
};
